export const getPopupPosition = (node: HTMLDivElement): { posX: number; posY: number } => {
    const rect = node.getBoundingClientRect();

    return {
        posX: rect.left + pageXOffset,
        posY: rect.bottom + pageYOffset,
    };
};
